import { graphql } from "../generated";
// @ts-expect-error - CatalogShowFragment is needed for the fragment spread
// eslint-disable-next-line
import { CatalogShowFragment } from "../fragments/CatalogShow.fragment";

// The Recommendations of the series details page (SHO-757). @authenticated,
// so fetched from a component, never by the route loader.
export const GET_RELATED_SHOWS = graphql(`
  query GetRelatedShows(
    $showId: ID!
    $limit: Int!
    $offset: Int! = 0
    $withProgression: Boolean! = false
    $withBookmarkState: Boolean! = false
  ) {
    relatedShows(showId: $showId, limit: $limit, offset: $offset) {
      shows {
        ...CatalogShowFragment
      }
    }
  }
`);
